<template>
  <div class="page-container">
    <sub-header>
      <template slot="title">{{$route.meta.title}}
      </template>
      <template slot="btn">
        <el-button type="primary"
                   size="medium"
                   v-has="'Upload'"
                   @click="openUpload(true)">{{$t('photo.Upload')}}</el-button>
      </template>
      <template slot="search">
        <el-row :gutter="20">
          <el-col :lg="4"
                  :md="6"
                  :sm="6"
                  :xs="6">
            <el-select v-model="condition.PlanId"
                       @visible-change="showSelect"
                       filterable
                       remote
                       size="mini"
                       style="width:100%"
                       clearable
                       :remote-method="remotePlanMethod"
                       :placeholder="$t('photo.SearchPlan')"
                       @change="search">
              <el-option v-for="i of planList"
                         :key="i.PlanId"
                         :label="i.Name"
                         :value="i.PlanId"></el-option>
            </el-select>
          </el-col>
          <el-col :lg="4"
                  :md="6"
                  :sm="6"
                  :xs="6">
            <el-input :placeholder="$t('photo.SearchTaskName')"
                      size="mini"
                      style="width:100%"
                      @change="search"
                      clearable
                      v-model="condition.TaskName"></el-input>
          </el-col>
          <el-col :lg="4"
                  :md="6"
                  :sm="6"
                  :xs="6">
            <el-input :placeholder="$t('photo.SearchRoom')"
                      size="mini"
                      style="width:100%"
                      @change="search"
                      clearable
                      v-model="condition.RoomName"></el-input>
          </el-col>
          <el-col :span="0.5">
            <el-button circle
                       type="primary"
                       size="mini"
                       @click="refresh"><i class="el-icon-refresh-right"></i></el-button>
          </el-col>
          <SortControl @sortList="sortList"
                       :orderBy="sortValue">
            <template slot="sort">
              <el-select size="mini"
                         @change="sort"
                         placeholder="Orderby"
                         v-model="sortBy">
                <el-option v-for="item in sortType"
                           :key="item.name"
                           :label="item.name"
                           :value="item.value"></el-option>
              </el-select>
            </template>
          </SortControl>
        </el-row>
      </template>
    </sub-header>
    <div class="main"
         v-loading="loading"
         :class="filter.showFilter?'main-showfilter':''">
      <div class="tool-btn"
           v-show="photoList.length > 0">
        <el-checkbox :indeterminate="isIndeterminate"
                     v-model="checkAll"
                     @change="handleCheckAllChange"> {{$t('photo.SelectAll')}}</el-checkbox>
        <span style="margin-left:15px;">
          <el-button type="primary"
                     @click="downloadPhotos"
                     size="mini"
                     :disabled="checkList.length <1 "> {{$t('photo.Download')}}</el-button>
          <el-button type="danger"
                     @click="deletePhotos"
                     size="mini"
                     v-has="'Upload'"
                     :disabled="checkList.length < 1  "> {{$t('photo.Delete')}}</el-button>
        </span>
      </div>
      <div class="
                     list-box">
        <myScroll style="width:100%;height:100%">
          <el-checkbox-group v-model="checkList"
                             @change="handleCheckedChange">
            <div class="cube-box"
                 v-for="(i, j) of photoList"
                 :key="i.DocFileId">
              <div class="photo-box">
                <div class="photo-img cover-show"
                     @mouseenter="showBigCover(j)"
                     @mouseleave="hideBigCover"
                     @click="showBigPhoto(i.url,i.Type === 'TaskVideo')">
                  <div v-if="i.Type === 'TaskVideo'"
                       class="videoPlayContent">
                    <div class="videoPlayDiv"><span class="videoPlay"></span></div>
                    <img style="width:100%;"
                         :src="i.videoThumbUrl" />
                  </div>
                  <img v-else
                       :src="i.url"
                       alt="">
                </div>
                <el-checkbox :label="i.DocFileId">
                  <span>{{i.TaskName ? $t('taskDialog.Task') + ':' : i.Name}}{{i.TaskName}}</span>
                  <span>{{i.LastUpdatedOn}}</span>
                </el-checkbox>
              </div>
            </div>
          </el-checkbox-group>
          <div v-if="photoList.length === 0"
               class="no-data">
            {{$t('photo.NoData')}}
          </div>
        </myScroll>
      </div>
      <page ref="pagination"
            :total="total"
            :PageSize="condition.PageSize"
            :PageIndex="condition.PageIndex"
            @handleCurrentChange="handleCurrentChange"></page>
    </div>

    <photoDialog :showDialog="photoDialog.showDialog"
                 @closeDialog="hideBigPhoto()"
                 :url="photoDialog.url"
                 :isVideo="photoDialog.isVideo"></photoDialog>
    <Uploading :showDialog="uploadDialog.showDialog"
               @closeDialog="closeUpload"
               :taskId="uploadDialog.taskId"
               :jobsiteId="uploadDialog.jobsiteId"
               :onlyPhotoVideo="uploadDialog.onlyPhotoVideo"></Uploading>
  </div>
</template>

<script>
import { getTaskPhoto, getTasksList, deleteTaskPhoto, getPlansList } from '@/api/config'
// import { GMTToStr } from '@/static/config'
import { mapState } from 'vuex'
import photoDialog from '@components/photo/photoDialog.vue'
import SortControl from '@components/common/sortBtnList'
import Uploading from '@components/uploading/uploading'
import axios from 'axios'

export default {
  data () {
    return {
      checkAll: false,
      isIndeterminate: false,
      loading: false,
      filter: {
        showFilter: false
      },
      condition: {
        JobsiteId: null,
        TaskId: null,
        TaskName: null,
        FileName: null,
        PlanId: null,
        RoomName: null,
        LastUpdatedOn: null,
        PageIndex: 1,
        PageSize: 30,
        OrderBy: 'CreatedOn desc'
      },
      total: 0,
      taskList: [],
      taskCondition: {
        Name: null,
        PageIndex: 1,
        PageSize: 20,
        OrderBy: 'LastUpdatedOn desc'
      },
      checkList: [],
      photoList: [],
      showCover: false,
      showUrl: '',
      cover: -1,
      uploadDialog: {
        showDialog: false,
        taskId: null,
        onlyPhotoVideo: false
      },
      photoDialog: {
        showDialog: false,
        url: '',
        isVideo: false
      },
      planList: [],
      planCondition: {
        Name: null,
        PageIndex: 1,
        PageSize: 20,
        OrderBy: 'LastUpdatedOn desc'
      },
      sortType: [
        {
          name: this.$t('photo.Name'),
          value: 'TaskName'
        }, {
          name: this.$t('photo.CreatedOn'),
          value: 'CreatedOn'
        }],
      sortValue: 'desc',
      sortBy: 'CreatedOn'
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'photoConditionOrderby'])
  },
  created () {
    this.setPhotoConditionOrderBy()
    this.getTaskPhoto()
    this.getTasksList()
    this.getPlansList()
  },
  mounted () {

  },
  watch: {

  },
  methods: {
    handleCheckAllChange (val) {
      this.checkList = val ? this.photoList.map(q => q.DocFileId) : []
      this.isIndeterminate = false
    },
    handleCheckedChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.photoList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.photoList.length
    },
    showSelect (e) {
      if (!e) {
        this.planCondition.Name = null
        this.getPlansList()
      }
    },
    closeFilter () {
      this.filter.showFilter = false
    },
    openFilter () {
      this.filter.showFilter = true
    },
    remoteMethod (query) {
      if (query !== '') {
        this.taskCondition.Name = query
        this.getTasksList()
      }
    },
    getTasksList () {
      this.taskCondition.JobsiteId = this.jobsiteID
      getTasksList(this.taskCondition).then(res => {
        this.taskList = res.Data
      })
    },
    refresh () {
      this.condition.TaskName = null
      this.condition.FileName = null
      this.condition.LastUpdatedOn = null
      this.condition.PlanId = null
      this.condition.RoomName = null
      this.getTaskPhoto()
      this.checkList = []
      this.checkAll = false
      this.isIndeterminate = false
    },
    handleCurrentChange (val) {
      this.condition.PageIndex = val
      this.getTaskPhoto()
    },
    search () {
      this.condition.PageIndex = 1
      this.getTaskPhoto()
      this.checkList = []
      this.checkAll = false
      this.isIndeterminate = false
    },
    sortList () {
      if (this.sortValue === 'asc') {
        this.sortValue = 'desc'
      } else {
        this.sortValue = 'asc'
      }
      this.sort()
    },
    sort () {
      this.condition.OrderBy = this.getPhotoConditionOrderBy()
      this.savePhotoConditionOrderBy()
      this.getTaskPhoto()
    },
    getTaskPhoto () {
      this.loading = true
      this.photoList = []
      this.condition.JobsiteId = this.jobsiteID
      this.condition.OrderBy = this.getPhotoConditionOrderBy()
      getTaskPhoto(this.condition).then(res => {
        res.Data.forEach(ele => {
          // ele.CreatedOnDate = GMTToStr(new Date(ele.CreatedOn))
          ele.LastUpdatedOn = this.$config.formatDate(new Date(ele.LastUpdatedOn), 'MM/dd/yyyy')
          ele.checked = false
          ele.url = this.$config.baseURL + '/api/Attachments/' + ele.DocFileId
          ele.videoThumbUrl = ele.url
          if (ele.Type === 'TaskVideo') {
            ele.videoThumbUrl += '?getVideoThumbImg=true'
          }
        })
        this.total = res.TotalCount
        this.photoList = res.Data
        this.loading = false
      })
    },
    showBigPhoto (url, isVideo) {
      this.photoDialog.showDialog = true
      this.photoDialog.url = url
      this.photoDialog.isVideo = isVideo
    },
    openUpload (onlyPhotoVideo) {
      this.uploadDialog.taskId = '0'
      this.uploadDialog.jobsiteId = this.jobsiteID
      this.uploadDialog.showDialog = true
      this.uploadDialog.onlyPhotoVideo = onlyPhotoVideo
    },
    closeUpload (needRefresh) {
      this.uploadDialog.showDialog = false
      if (needRefresh === true) {
        this.getTaskPhoto()
      }
    },
    hideBigPhoto () {
      this.photoDialog.showDialog = false
      this.photoDialog.url = ''
      this.photoDialog.isVideo = false
    },
    showBigCover (index) {
      this.cover = index
    },
    hideBigCover () {
      this.cover = -1
    },
    deletePhotos () {
      if (this.checkList.length < 1) {
        this.$notify.info({
          title: this.$t('photo.PleaseSelectPhoto')
        })
      } else {
        this.$confirm(this.$t('photo.AreYouSureYouWantToDeleteThesePhotos'), this.$t('photo.TIPS'), {
          confirmButtonText: this.$t('photo.Yes'),
          cancelButtonText: this.$t('photo.No'),
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          deleteTaskPhoto(this.checkList).then(res => {
            this.$refs.pagination.handleDelete(this.checkList.length)
            this.checkList = []
            this.checkAll = false
            this.isIndeterminate = false
          })
        }).catch(() => {
        })
      }
    },
    downloadPhotos () {
      let that = this
      if (this.checkList.length < 1) {
        this.$notify.info({
          title: this.$t('photo.PleaseSelectPhoto')
        })
      } else {
        const loading = this.$loading({
          lock: true,
          text: this.$t('welcome.Loading'),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let postData = this.checkList.map(q => ({ DocFileId: q, IsFolder: false }))
        axios({
          method: 'Post',
          url: this.$config.baseURL + '/api/Attachments/DownloadFiles',
          data: { Files: postData },
          responseType: 'blob',
          'headers': {
            'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
            'Authorization': 'Bearer ' + this.$store.state.userInfo.Token
          }
        }).then((res) => {
          let blob = new Blob([res])
          const fileName = 'Photos.zip'
          const link = document.createElement('a')// 创建a标签
          link.download = fileName
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(link.href) // 释放url
          document.body.removeChild(link)
          loading.close()
        }).catch((err) => {
          if (err.response.data.type.includes('application/json')) {
            let reader = new FileReader()
            reader.onload = function (event) {
              let content = reader.result
              let message = JSON.parse(content).Message
              that.$notify.closeAll()
              that.$notify.warning({
                title: message === 'Not Found' ? that.$t('photo.NotFound') : that.$t(message),
                showClose: false,
                duration: 1000
              })
            }
            reader.readAsText(err.response.data)
          } else {
            that.$notify.closeAll()
            that.$notify.warning({
              title: err.response.data.Message,
              showClose: false,
              duration: 1000
            })
          }
          loading.close()
        })
      }
    },
    remotePlanMethod (query) {
      this.planCondition.Name = query
      this.getPlansList()
    },
    getPlansList () {
      this.planCondition.JobsiteId = this.jobsiteID
      getPlansList(this.planCondition).then(res => {
        this.planList = res.Data
      })
    },
    getPhotoConditionOrderBySplit () {
      return ' '
    },
    getPhotoConditionOrderBy () {
      return this.sortBy + this.getPhotoConditionOrderBySplit() + this.sortValue
    },
    setPhotoConditionOrderBy () {
      let arr = this.photoConditionOrderby.split(this.getPhotoConditionOrderBySplit())
      if (arr && arr.length === 2) {
        this.sortBy = arr[0]
        this.sortValue = arr[1]
      }
    },
    savePhotoConditionOrderBy () {
      this.$store.commit('setPhotoConditionOrderby', this.condition.OrderBy)
    }
  },
  components: {
    photoDialog,
    Uploading,
    SortControl
  }
}
</script>
<style lang="scss">
.photo-box {
  .el-checkbox {
    width: 100%;
    margin-top: 6px;
    .el-checkbox__input {
      position: absolute;
      top: 5px;
    }
    .el-checkbox__label {
      width: 90%;
      padding-left: 20px;
      span {
        display: block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #909399;
        &:first-child {
          color: #303133;
          font-size: 16px;
          margin-top: 4px;
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.list-box {
  flex: 1;
  height: 0;
  position: relative;
  .cube-box {
    box-sizing: border-box;
    width: 16.6%;
    padding: 0 8px;
    float: left;
    overflow: hidden;
    margin-bottom: 16px;
    .photo-box {
      padding: 8px;
      background-color: #fff;
      overflow: hidden;
      border: 1px solid #ccc;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      .photo-img {
        height: 160px;
        width: 100%;
        background-color: #fff;
        cursor: pointer;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          max-width: 100%;
          max-height: 100%;
        }
        .cover {
          width: 100%;
          -webkit-transition: bottom 0.5s;
          transition: bottom 0.5s;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          position: absolute;
          bottom: -100%;
          z-index: 10;
          cursor: pointer;
          i {
            font-size: 36px;
            color: #fff;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .cover-show {
          bottom: 0;
        }
        video {
          height: 100%;
          width: 100%;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        }
        .videoPlayContent {
          cursor: pointer;
          width: 100%;
          height: 100%;
          position: relative;
          .videoPlayDiv {
            position: absolute;
            z-index: 1;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.4);
          }
          .videoPlay {
            background: url(../../../assets/image/play.png) no-repeat;
            background-position: 50% 50%;
            cursor: pointer;
            color: buttontext;
            width: 100%;
            height: 100%;
            display: inline-block;
          }
        }
      }
    }
  }
}

@media (max-width: 1120px) {
  .main {
    .list-box {
      .cube-box {
        width: 33.3%;
      }
    }
  }
}
</style>
